import React from 'react';

import { PopUp } from './styles';

const PopUpConfirmacao: React.FC = ({ children }) => (
  <PopUp className="shadow border rounded">{children}</PopUp>
);

export default PopUpConfirmacao;
